module.exports = __webpack_public_path__ + "img/LernerSports_computer_ipad.9eb80ece.jpg";